import * as actionTypes from '../actionTypes';
import axios from '../../../services/axios';
import { setMessage } from '../message';

export const loadLibraryBooks = () => {
    return {
        type: actionTypes.LOAD_LIBRARY_BOOKS,
    };
};

export const setLibraryBooks = (books) => {
    return {
        type: actionTypes.SET_LIBRARY_BOOKS,
        books: books,
    };
};

export const getLibraryBooks = () => {
    return (dispatch) => {
        dispatch(loadLibraryBooks());
        axios
            .get(`/api/v1/library/books`)
            .then((response) => {
                dispatch(setLibraryBooks(response.data));
            })
            .catch((_) => {
                dispatch(
                    setMessage({
                        type: 'warning',
                        text: 'Не удалось подключиться к серверу.',
                    })
                );
            });
    };
};
